import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function EncryptedFillIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M10.74 14.75h2.52l-.566-3.158a1.7 1.7 0 0 0 .759-.633A1.7 1.7 0 0 0 13.74 10q0-.72-.51-1.23T12 8.26t-1.23.51-.51 1.23q0 .527.287.959a1.7 1.7 0 0 0 .759.633zM12 21.48q-3.245-.884-5.372-3.818Q4.5 14.727 4.5 11.1V5.346L12 2.54l7.5 2.807V11.1q0 3.627-2.128 6.562-2.128 2.934-5.372 3.819z" />
    </Icon>
  );
}

EncryptedFillIcon.displayName = 'EncryptedFillIcon';
